export default __webpack_public_path__ + "static/media/background1.55d6ddc6.png";